import { Injectable } from '@angular/core';
import { Status, Itinerary } from './itineray.model';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ItineraryExpensesCalculatorService } from './itinerary-expenses-calculator.service';
import { PoisGeneratorService } from './pois-generator.service';
import { AffiliationLinkGeneratorService } from './affiliation-link-generator.service';
import { ItineraryReviewCheckupDialogComponent } from './itinerary-review-checkup-dialog/itinerary-review-checkup-dialog.component';
import { ItineraryService } from './itinerary.service';

@Injectable({
  providedIn: 'root'
})
export class ItineraryWorkflowService {

  constructor(
    public itineraryService: ItineraryService,
    private snackBar: MatSnackBar,
    private expensesCalculator: ItineraryExpensesCalculatorService,
    private poisGenerator: PoisGeneratorService,
    private affiliationLinkGeneratorService: AffiliationLinkGeneratorService,
    private matDialog: MatDialog
  ) { }

  init(itinerary: Itinerary) {
    itinerary.status = Status.IN_PROGRESS;
    itinerary.reservations = {
      flights: [],
      accomodations: [],
      buses: [],
      cars: [],
      ferries: [],
      trains: []
    };
    itinerary.days = [];
    itinerary.expenses = {
      min: null,
      max: null,
    };
  }

  presave(itinerary: Itinerary) {
    this.expensesCalculator.calulate(itinerary);
    this.poisGenerator.generate(itinerary);
    this.affiliationLinkGeneratorService.generate(itinerary);
  }

  save(itinerary: Itinerary) {

    this.presave(itinerary);

    itinerary.status = Status.IN_PROGRESS;

    this.itineraryService
      .update(itinerary)

      .then(() => {
        this.snackBar.open("Itinerario salvato 😉", null, {
          duration: 1000
        });
      })
      .catch((e) => {
        console.error(e);
        this.snackBar
          .open("Errore durante il salvataggio dell'itinerario 😢", "Riprova", {
            duration: 4000
          })
          .onAction()
          .subscribe(() => {
            this.save(itinerary);
          });
      });
  }

  async review(itinerary: Itinerary) {

    this.presave(itinerary);

    itinerary.status = Status.PROCESSING;

    this.itineraryService
      .update(itinerary)

      .then(() => {
        this.snackBar.open("Itinerario inviato in revisione 😉", null, {
          duration: 1000
        });
      })
      .catch((e) => {
        console.error(e);
        this.snackBar
          .open("Errore durante l'invio in revisione dell'itinerario 😢", "Riprova", {
            duration: 4000
          })
          .onAction()
          .subscribe(() => {
            this.review(itinerary);
          });
      });
  }

  rimodifica(itinerary: Itinerary) {
    itinerary.status = Status.IN_PROGRESS;
  }

  consegna(itinerary: Itinerary) {
    if (!confirm("Sei veramente sicuro di consegnare?" + (itinerary.test ? "" : "\nL'itinerario sarà consegnato al cliente in modo automatizzato via email."))) return;

    itinerary.status = Status.DONE;

    this.itineraryService
      .update(itinerary)

      .then(() => {
        this.snackBar.open("Itinerario consegnato 😉", null, {
          duration: 1000
        });
      })
      .catch((e) => {
        console.error(e);
        this.snackBar
          .open("Errore durante la consegna dell'itinerario 😢", "Riprova", {
            duration: 4000
          })
          .onAction()
          .subscribe(() => {
            this.consegna(itinerary);
          });
      });
  }
}
